import React from "react";
const svgClr = {
  Email: "blue",
  SMS: "blue",
  "Contact Log": "blue",
  pdf: "red",
  doc: "blue",
  docx: "blue",
  zip: "yellow",
  jpeg: "blue",
  jpg: "blue",
  png: "blue",
  xlsx: "green",
  txt: "gray"
};
export const svg = {
  jpeg: (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      ></path>
    </svg>
  ),
  jpg: (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      ></path>
    </svg>
  ),
  png: (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      ></path>
    </svg>
  ),
  Email: (
    <svg
      className="w-6 h-6 "
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      ></path>
    </svg>
  ),
  SMS: (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
      ></path>
    </svg>
  ),
  "Contact Log": (
    <svg
      className="w-6 h-6"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
      ></path>
    </svg>
  ),
  pdf: (
    <div className="relative">
      <span className="pl-1half pt-2 absolute text-xxxs font-bold">PdF</span>
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        ></path>
      </svg>
    </div>
  ),
  doc: (
    <div className="">
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    </div>
  ),
  docx: (
    <div className="">
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    </div>
  ),
  zip: (
    <div className="">
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
        />
      </svg>
    </div>
  ),
  xlsx: (
    <div>
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
        />
      </svg>
    </div>
  ),
  csv: (
    <svg
      className="w-6 h-6"
      viewBox="0 0 48 48"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 7 2 L 7 48 L 43 48 L 43 15.410156 L 29.183594 2 Z M 9 4 L 28 4 L 28 17 L 41 17 L 41 46 L 9 46 Z M 30 5.578125 L 39.707031 15 L 30 15 Z M 20.234375 23.710938 C 18.265625 23.710938 16.152344 25.195313 16.152344 29.003906 C 16.152344 31.871094 17.382813 34 19.964844 34 C 20.652344 34 21.207031 33.894531 21.492188 33.761719 L 21.296875 32.109375 C 21.058594 32.183594 20.679688 32.261719 20.351563 32.261719 C 19.152344 32.261719 18.234375 31.316406 18.234375 28.902344 C 18.234375 26.394531 19.242188 25.4375 20.351563 25.4375 C 20.785156 25.4375 21.042969 25.527344 21.265625 25.628906 L 21.597656 23.980469 C 21.402344 23.84375 20.921875 23.710938 20.234375 23.710938 Z M 25.375 23.710938 C 23.261719 23.710938 22.183594 25.058594 22.183594 26.679688 C 22.183594 27.59375 22.707031 28.660156 24.085938 29.5 C 24.941406 30.054688 25.390625 30.414063 25.390625 31.152344 C 25.390625 31.808594 24.941406 32.289063 24.011719 32.289063 C 23.441406 32.289063 22.75 32.125 22.347656 31.902344 L 22.0625 33.59375 C 22.394531 33.789063 23.1875 34 23.996094 34 C 25.976563 34 27.34375 32.785156 27.34375 30.9375 C 27.34375 29.875 26.847656 28.855469 25.515625 28.046875 C 24.417969 27.386719 24.117188 27.070313 24.117188 26.46875 C 24.117188 25.929688 24.519531 25.421875 25.359375 25.421875 C 25.929688 25.421875 26.367188 25.585938 26.652344 25.765625 L 26.96875 24.070313 C 26.667969 23.890625 26.035156 23.710938 25.375 23.710938 Z M 27.628906 23.800781 L 29.890625 33.90625 L 32.09375 33.90625 L 34.40625 23.800781 L 32.246094 23.800781 L 31.558594 28.121094 C 31.375 29.257813 31.210938 30.476563 31.078125 31.675781 L 31.046875 31.675781 C 30.914063 30.492188 30.703125 29.242188 30.523438 28.164063 L 29.800781 23.800781 Z" />
    </svg>
  ),
  txt: (
    <svg
      className="w-6 h-6"
      viewBox="0 0 48 48"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 7 2 L 7 48 L 43 48 L 43 15.410156 L 29.183594 2 Z M 9 4 L 28 4 L 28 17 L 41 17 L 41 46 L 9 46 Z M 30 5.578125 L 39.707031 15 L 30 15 Z M 22.011719 23.554688 L 23.824219 28.488281 L 21.933594 33.664063 L 23.882813 33.664063 L 24.421875 31.835938 C 24.574219 31.265625 24.738281 30.652344 24.902344 30.003906 L 24.933594 30.003906 C 25.113281 30.652344 25.277344 31.222656 25.472656 31.808594 L 26.117188 33.664063 L 28.144531 33.664063 L 26.152344 28.578125 L 28.039063 23.554688 L 26.074219 23.554688 L 25.5625 25.402344 C 25.429688 25.957031 25.308594 26.4375 25.144531 27.050781 L 25.113281 27.050781 C 24.949219 26.480469 24.816406 25.953125 24.652344 25.429688 L 24.0625 23.554688 Z M 15.949219 23.558594 L 15.949219 25.371094 L 17.734375 25.371094 L 17.734375 33.664063 L 19.699219 33.664063 L 19.699219 25.371094 L 21.5 25.371094 L 21.5 23.558594 Z M 28.519531 23.558594 L 28.519531 25.371094 L 30.300781 25.371094 L 30.300781 33.664063 L 32.265625 33.664063 L 32.265625 25.371094 L 34.066406 25.371094 L 34.066406 23.558594 Z" />
    </svg>
  ),
};

const DataTile = ({ id, svgType, title, description1, description2 }) => {
  return (
    <div
      id={id}
      className="flex h-full flex-col dark:bg-white/10 bg-gray-50 text-blue-400 overflow-hidden shadow-md hover:shadow-lg dark:hover:shadow-black rounded-lg"
    >
      <div className="flex-grow p-3">
        <div className="flex items-center">
          <div
            className={
              "flex-shrink-0 text-" +
              svgClr[svgType] +
              "-500 rounded-md p-1"
            }
          >
            {svg[svgType]}
          </div>
          <div className="ml-5 w-0 flex-1 ">
            <dt className="flex text-sm  text-green-600 truncate">
              <p className="truncate"  title={title}>{title}</p>
            </dt>
            <dt className="pt-1 flex text-xxs mt-1 font-medium dark:text-gray-400 text-gray-500 truncate">
              {description1}
            </dt>
            <dt className="text-xxs items-baseline mt-1 font-medium dark:text-gray-400 text-gray-500 truncate">
              {description2}
            </dt>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataTile;
